import { render, staticRenderFns } from "./BaseTableCard.vue?vue&type=template&id=c10dcdd2"
import script from "./BaseTableCard.vue?vue&type=script&lang=js"
export * from "./BaseTableCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports